import "@styles/style.scss";

import { Utils } from "@scripts/components/functions.js";
import { Wishlist } from "@scripts/components/wishlist.js";

// its floating nav bar height, so substract this number from all smooth scroll positions
let TOP_OFFSET = 52;

// superset navigatin bar
window.ezqr = {
  nav: {}
}

/* Edit link fix */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll(`.ez-edit`).forEach(editLink => {
    editLink.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  })
});

/* Navigation sidebar toggler */
document.addEventListener('DOMContentLoaded', function () {
  const navArea = document.querySelector('.nav-area');
  const navAreaToggler = document.querySelector('.nav-toggler');
  const navAreaOverlay = document.querySelector('.nav-overlay');
  const bodyClassWhenToggled = 'sidebar--toggled';

  // Return early if the navigation doesn't exist.
  if ('undefined' === typeof navArea || 'undefined' === typeof navAreaToggler) {
    return;
  }

  // Toggle the .nav-area--toggled class each time the button is clicked.
  navAreaToggler.addEventListener('click', function () {
    toggleState(navAreaToggler, navArea);
  });

  if (navAreaOverlay) {
    navAreaOverlay.addEventListener('click', function () {
      if (document.body.classList.contains(bodyClassWhenToggled))
        toggleState(navAreaToggler, navArea);
    }, true);
  }

  navArea.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', function () {
      if (document.body.classList.contains(bodyClassWhenToggled))
        toggleState(navAreaToggler, navArea);
    }, true);
  });

  function toggleState(toggler, targetArea) {
    toggler.classList.toggle('nav-toggler--toggled');
    targetArea.classList.toggle('nav-area--toggled');

    document.body.classList.toggle(bodyClassWhenToggled);

    if (toggler.getAttribute('aria-expanded') === 'true') {
      toggler.setAttribute('aria-expanded', 'false');
    } else {
      toggler.setAttribute('aria-expanded', 'true');
    }
  }
});

var Popup = {
  root: null,
  class: '',
  splide: null,
  init: function (popupClass = 'popup') {
    let that = this;
    that.class = popupClass;
    that.root = document.querySelector('.' + popupClass)
    if (that.root instanceof HTMLElement) {
      that.root.querySelectorAll(`.${popupClass}__close`).forEach(pb => {
        pb.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          // console.log('triggered')
          that.trigger();
        });
      });
    }
    // let closeBtn = that.root.querySelector('.' + popupClass + '__close');
    // if (closeBtn instanceof HTMLElement) {
    //   closeBtn.addEventListener('click', function(){
    //     that.trigger()
    //   })
    // }
  },
  trigger: function (move = false, index = null) {
    let that = this;
    // console.log(this, that);
    setTimeout(function () {
      that.root.classList.toggle(that.class + '--visible');
      if (move && index !== null) {
        that.splide.go(index, true);
        // console.log(that.splide)
      }
      // if ( that.root.classList.contains(that.class + '--visible') ) {
      //   that.splide.options = { keyboard: 'global' };
      // } else {
      //   that.splide.options = { keyboard: false };
      // }
    }, 150);
  },
  setSplide: function (splide) {
    this.splide = splide;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // initialize and start wishlist
  const wishlist = Wishlist();
  wishlist
    .init()
    .start();

  Popup.init()

  /* ------------------- FAB - smooth scroll top ------------------------- */
  const fab = document.querySelector('.fab');
  if (fab instanceof HTMLElement) {
    let fabVisibilityHandler = function () {
      let currentHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      if (window.scrollY > (currentHeight - TOP_OFFSET)) {
        fab.style.visibility = null;
      } else {
        fab.style.visibility = 'hidden';
      }
    }
    fabVisibilityHandler();
    ['scroll'].forEach(function (e) {
      window.addEventListener(e, fabVisibilityHandler, { passive: true });
    });
    fab.addEventListener('click', function (event) {
      window.scrollTo({ top: TOP_OFFSET, behavior: 'smooth' });
    })
  }

  /* Smooth scrolling for all hash nav */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      Utils.scrollToElement(null, link.hash, TOP_OFFSET);
    });
  });

  /* ------------------- JS Tabs Nav ------------------------- */
  let tabsClass = 'tabs';
  let tabsNavItemClass = tabsClass + '__nav-item';
  let tabsNavItemActiveClass = tabsNavItemClass + '--active';
  let tabsNavPaneClass = tabsClass + '__pane';
  let tabsNavPaneActiveClass = tabsNavPaneClass + '--active';

  const navTabs = document.querySelectorAll('.' + tabsClass);
  if (navTabs) {
    navTabs.forEach(function (navTab) {
      const navTabsItems = navTab.querySelectorAll('.' + tabsNavItemClass);

      function navTabActivate(event) {
        event.preventDefault();
        let clickedTab = event.target;

        // prevent unneded changes if current
        if (!clickedTab.classList.contains(tabsNavItemActiveClass)) {

          /* Dispatch tabswitch event () */
          window.dispatchEvent(
            new CustomEvent("tabswitch", {
              bubbles: true,
              detail: { tabId: () => clickedTab.dataset?.tabId },
            }));

          for (let i = 0; i < navTabsItems.length; i++) {
            if (navTabsItems[i].dataset.tabId == clickedTab.dataset?.tabId) {
              navTabsItems[i].classList.add(tabsNavItemActiveClass);
            } else {
              navTabsItems[i].classList.remove(tabsNavItemActiveClass);
            }
          }

          let tabContentPanes = navTab.querySelectorAll('.' + tabsNavPaneClass);
          for (i = 0; i < tabContentPanes.length; i++) {
            tabContentPanes[i].classList.remove(tabsNavPaneActiveClass);
          }

          /* Get Tab ID from data-tab-id */
          let tabId = clickedTab.dataset?.tabId;
          let tabContentPane = navTab.querySelector('#' + tabId);
          if (tabContentPane instanceof HTMLElement) {
            tabContentPane.classList.add(tabsNavPaneActiveClass);
          } else {
            console.warn('Nav: tab pane not found');
          }

          /* Update */
          try {
            let tabPosition = clickedTab.getBoundingClientRect().top + window.scrollY;
            let tabPanePosition = tabContentPane.getBoundingClientRect().top + window.scrollY;

            /* if second nav exists - nav in start section */
            if (tabPosition > tabPanePosition) {
              // window.scrollTo({top: tabPanePosition, behavior: 'smooth'});
              Utils.scrollToElement(tabContentPane, '', TOP_OFFSET)
            }
          } catch (error) {
            console.warn('Tab navigation error');
          }

        }

      }

      if (navTabsItems) {
        for (i = 0; i < navTabsItems.length; i++) {
          navTabsItems[i].addEventListener("click", navTabActivate)
        }
      }
    })
  }

  /* ------------------- Sticky Nav Menu ------------------------- */
  var stickyStartPos = -1;
  const ezqrNavBars = document.querySelectorAll('.js-ez-nav-endless');

  function findPositionY(element) {
    let currentTop = 0;
    if (element.offsetParent !== null && element.offsetParent) {
      while (element.offsetParent) {
        currentTop += element.offsetTop;
        element = element.offsetParent;
      }
      currentTop += element.offsetTop;
    } else if (element.y) {
      currentTop += element.y;
    }
    return currentTop;
  }

  let navigationScrollingHandler = function () {
    ezqrNavBars.forEach(ezqrNavBar => {
      if (stickyStartPos < 0) {
        stickyStartPos = findPositionY(ezqrNavBar);
      }
      if (window.scrollY > stickyStartPos - TOP_OFFSET) {
        ezqrNavBar.classList.add("ez-nav-endless--sticky");
      } else {
        ezqrNavBar.classList.remove("ez-nav-endless--sticky");
      }
    });
  };

  /* NOTE: custom event tabswith dispatched if tabs changed */
  ['scroll', 'resize', 'tabswitch'].forEach(function (e) {
    window.addEventListener(e, navigationScrollingHandler, (e == 'scroll' ? { passive: true } : false));
  });

  /* ------------------- Sliders (navigation) ------------------------- */
  if (window['Splide']) {
    /* ------------------- Categories List in Superset ------------------------- */
    const spliders = document.querySelectorAll('.js-ez-nav .splide');
    spliders.forEach(splider => {

      let menuNavCarousel = new window['Splide'](splider, {
        type: 'loop',
        clones: 0,
        focus: 0,
        speed: 330,
        rewind: false,
        drag: true,
        gap: '8px',
        omitEnd: true,
        autoplay: false,
        pagination: false,
        trimSpace: false,
        autoHeight: true,
        updateOnMove: true,
      }
      );

      /* Updates the bar width whenever the carousel moves */
      let progressbar = menuNavCarousel.root.querySelector('.splide__progress-bar');
      if (progressbar) {
        menuNavCarousel.on('mounted move', function () {
          var end = menuNavCarousel.Components.Controller.getEnd() + 1;
          var rate = Math.min((menuNavCarousel.index + 1) / end, 1);
          progressbar.style.width = String(100 * rate) + '%';
        });
      }
      // console.log(menuNavCarousel);

      /* Move carousel when slide clicked */
      menuNavCarousel.on('click', function (Slide, e) {
        menuNavCarousel.go(Slide.index);
      });

      /* Mount carousel element */
      menuNavCarousel.mount();

      /* Add to global navs list */
      if (splider.dataset?.superset) window.ezqr.nav[splider.dataset?.superset] = menuNavCarousel;

    });

    /* ------------------- Global Items Popup Slider ------------------------- */
    const popupSplideElement = document.querySelector('.popup__nav .splide.popup-slider');
    if (popupSplideElement instanceof HTMLElement) {

      let popupNavOptions = {
        type: 'loop',
        clones: 0,
        rewind: false,
        focus: 'center',
        speed: 200,
        drag: true,
        omitEnd: true,
        autoplay: false,
        mediaQuery: 'min',
        pagination: false,
        trimSpace: true,
        updateOnMove: true,
        width: '100%',
        arrows: false,
        perPage: 1,
        perMove: 1,
      };

      // popup nav direction
      if (window?._EZQR_SETTINGS?.template?.popupnav !== undefined) {
        if (window._EZQR_SETTINGS.template.popupnav == 'vertical') {
          popupNavOptions = Object.assign({}, popupNavOptions, {
            height: '100svh',
            direction: 'ttb',
          });
        } else if (window._EZQR_SETTINGS.template.popupnav == 'horizontal') {
          popupNavOptions = Object.assign({}, popupNavOptions, {
            autoHeight: true,
          });
        }
      }
      let popupSplide = new Splide(popupSplideElement, popupNavOptions);

      /* background page navigation while slider item move */
      popupSplide.on('move', () => {
        ezItemDataId = popupSplide.Components.Slides.getAt(popupSplide.index).slide.querySelector('.popup__item').dataset.id;
        ezItemOnPage = document.querySelector('.ez-menus .ezitem[data-id="' + ezItemDataId + '"]')
        Utils.scrollToElement(ezItemOnPage, '', TOP_OFFSET);
      });

      popupSplide.on('mounted', () => {
        Popup.setSplide(popupSplide);
      })

      popupSplide.mount();

      /* slider-into-slider */
      popupSplideElement.querySelectorAll('.splide__slide .splide.item-gallery-slider').forEach(itemGalleryElement => {
        let itemGallerySplide = new Splide(itemGalleryElement, {
          type: 'loop',
          perPage: 1,
          clones: 0,
          rewind: false,
          focus: 'center',
          speed: 250,
          drag: false,
          omitEnd: true,
          autoplay: false,
          trimSpace: true,
          updateOnMove: true,
          width: '100%',
          height: '100%',
          autoHeight: true,
          pagination: true,
        });

        itemGallerySplide.mount();
      });
    }

    const homeGalleryElement = document.querySelector('.ez-gallery__slider.splide');
    if (homeGalleryElement instanceof HTMLElement) {
        let homeGallerySplide = new Splide(homeGalleryElement, {
          type     : 'loop',
          perPage  : 5,
          perMove  : 1,
          gap      : '16px',
          rewind   : false,
          speed    : 250,
          drag     : 'free',
          omitEnd  : true,
          autoplay : false,
          trimSpace: true,
          updateOnMove: true,
          autoHeight: true,
          pagination: false,
          arrows: false,
          waitForTransition: true,
          breakpoints: {
            1199: {
              perPage: 3,
            },
            1919: {
              perPage: 4,
            },
            479: {
              fixedWidth: '35%',
            },
          }
        });
        homeGallerySplide.mount();
    }
    const homeReviewsElement = document.querySelector('.ez-reviews__slider.splide');
    if (homeReviewsElement instanceof HTMLElement) {
      let isAutoScroll = homeReviewsElement?.dataset?.autoScroll ? true : false;
        let homeReviewsSplide = new Splide(homeReviewsElement, {
          type     : 'loop',
          perPage  : 4,
          perMove  : 1,
          gap      : '16px',
          rewind   : false,
          focus    : 0,
          speed    : 250,
          drag     : 'free',
          omitEnd  : true,
          autoplay : false,
          trimSpace: true,
          updateOnMove: true,
          autoHeight: true,
          pagination: false,
          arrows: false,
          waitForTransition: true,
          autoScroll: {
            speed: 0.5,
          },
          breakpoints: {
            1199: {
              perPage: 3,
            },
            991: {
              fixedWidth: '40%',
            },
            479: {
              fixedWidth: '67%',
              autoScroll: {
                speed: 0.5,
              },
            },
          }
        });
      if (window['AutoScroll'] && isAutoScroll) {
        homeReviewsSplide.mount( { AutoScroll } ); 
      } else {
        homeReviewsSplide.mount();
      }
    }
  } else {
    console.warn('Splide: not detected, remove additional classes');
    document.querySelectorAll('.splide').forEach(splider => {
      splider.classList.remove('splide');
    })
  }


  /* ------------------- Track Menus Position ------------------------- */
  const endlessNavBar = document.querySelector('.js-ez-nav-endless');
  const categories = document.querySelectorAll('.ez-category');
  const supersets = document.querySelectorAll('.ez-menu-superset');

  // console.log(endlessNavBar, categories, supersets);

  supersets.forEach(s => {
    if (s.parentElement.parentElement.classList.contains('tabs__pane--active')) {
      s.classList.add('is-active')
    }
  });

  let topActivatePosition = 96;
  let bottomDeactivatePosition = topActivatePosition; //120;

  let next = null;
  let current = null;
  let prev = null;
  window.addEventListener('scroll', (evt) => {

    for (let i = 0; i < supersets.length; i++) {
      let supersetRectangle = supersets[i].getBoundingClientRect();
      if (supersetRectangle.top < topActivatePosition && supersetRectangle.bottom > bottomDeactivatePosition) {
        if (!supersets[i].classList.contains('is-active')) {
          supersets[i].classList.add('is-active');
          endlessNavBar.querySelector('.ez-nav[data-superset="' + supersets[i].dataset?.superset + '"]').classList.add('is-active');
          next = supersets[i + 1];
          current = supersets[i]
          prev = supersets[i - 1];
        }
      } else {
        supersets[i].classList.remove('is-active')
        endlessNavBar.querySelector('.ez-nav[data-superset="' + supersets[i].dataset?.superset + '"]').classList.remove('is-active');
      }
    }
    // for(let i = 0; i < supersets.length; i++) {
    //   let supersetClientRect = supersets[i].getBoundingClientRect();
    //   if ( supersetClientRect.top < topActivatePosition && supersetClientRect.bottom > bottomDeactivatePosition ) {
    //     // console.log(supersets[i], supersetClientRect.bottom)
    //     if ( !supersets[i].classList.contains('is-active') ) {
    //       supersets[i].classList.add('is-active');
    //       endlessNavBar.querySelector('.ez-nav[data-superset="' + supersets[i].dataset?.superset + '"]').classList.add('is-active');
    //     }
    //   } else {
    //     supersets[i].classList.remove('is-active')
    //     endlessNavBar.querySelector('.ez-nav[data-superset="' + supersets[i].dataset?.superset + '"]').classList.remove('is-active');
    //   }
    // }

    // supersets.forEach(superset => {
    //   let supersetClientRect = superset.getBoundingClientRect();
    //   if ( supersetClientRect.top < topActivatePosition && supersetClientRect.bottom > bottomDeactivatePosition ) {
    //     if ( !superset.classList.contains('is-active') ) {
    //       superset.classList.add('is-active');
    //       endlessNavBar.querySelector('.ez-nav[data-superset="' + superset.dataset?.superset + '"]').classList.add('is-active');
    //     }
    //   } else {
    //     superset.classList.remove('is-active')
    //     endlessNavBar.querySelector('.ez-nav[data-superset="' + superset.dataset?.superset + '"]').classList.remove('is-active');
    //   }
    // });

    categories.forEach(category => {
      let superset = category.dataset.superset;
      let supersetNav = superset != undefined && window.ezqr.nav[superset] != undefined ? window.ezqr.nav[superset] : '';
      let index = category.dataset?.index != undefined ? parseInt(category.dataset?.index, 10) : undefined;

      let sectionClientRect = category.getBoundingClientRect();
      if (sectionClientRect.top < topActivatePosition && sectionClientRect.bottom > bottomDeactivatePosition) {
        // TODO: track active state
        if (!category.classList.contains('is-active')) {

          category.classList.add('is-active')

          // console.log(supersetNav.index, index);
          if (superset != undefined && index != undefined && supersetNav != undefined) {
            if (supersetNav.index != index) {
              supersetNav.go(index);
            }
          }
        }
      } else {
        category.classList.remove('is-active')
      }
    });

  }, { passive: true });
  /*--------------------------------------------------------------------------------------------------------------------*/

  let ezItems = document.querySelectorAll('.ez-menus .ezitem');
  ezItems.forEach(ezItem => {
    ezItem.addEventListener('click', evt => {
      let goToIndex = null;
      if (Popup.splide !== null) {

        let slides = Popup.splide.Components.Slides.filter('[data-slide-id="' + ezItem.dataset?.id + '"]');
        if (slides.length && slides[0]) {
          goToIndex = slides[0].index
        }
      }

      if (goToIndex !== null) {
        Popup.trigger(true, goToIndex);
      } else {
        Popup.trigger();
      }
    });


    Popup.root.querySelectorAll('.readmore').forEach(readmore => {
      readmore.addEventListener('click', function (event) {
        popupContentClass = 'popup__item-content';
        popupContent = readmore.closest('.' + popupContentClass);
        popupContent.classList.toggle(popupContentClass + '--toggled');
        readmore.classList.toggle('readmore--toggled');
      });
    })

  });
});


// dynamic gallery
document.addEventListener('DOMContentLoaded', () => {
  // check lib is accessible
  if (window['PhotoSwipeLightbox']) {
    let galleryItemsList = document.querySelector('.ez-gallery__list');
    if (galleryItemsList instanceof HTMLElement) {
      // prepare items if not exists (legacy version)
      galleryItemsList.querySelectorAll('.ez-gallery__item').forEach((item) => {
        if (item.tagName.toLowerCase() === 'a') return;
        const img = item.querySelector('img');
        if (!img) return;
        const href = img.currentSrc || img.getAttribute('src');
        if (!href) return;
        const a = document.createElement('a');
        a.className = item.className;
        a.href = href;
        a.rel = 'noopener noreferrer';
        const w = parseInt(img.getAttribute('width'), 10);
        const h = parseInt(img.getAttribute('height'), 10);
        if (w && h) {
          a.setAttribute('data-pswp-width', w);
          a.setAttribute('data-pswp-height', h);
        }
        while (item.firstChild) a.appendChild(item.firstChild);
        item.replaceWith(a);
        console.log(a);
      });
      // assign lib to items and load core
        const lightbox = new PhotoSwipeLightbox({
          gallery: '.ez-gallery__list',
          children: 'a.ez-gallery__item',
          pswpModule: () => import('photoswipe'),
        });
        lightbox.init();
    }
  } else {
    console.log('Lightbox is not deteced')
  }
});